import z from "zod";

const FormSchema = z.object({
  name: z.string().min(1, "Name is required"),
  scopes: z.record(z.string(), z.boolean()),
});
export default FormSchema;
